module.exports = __webpack_public_path__ + "img/steak.1924a66c.jpg";